import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, debounceTime, distinctUntilChanged, finalize, of, Subscription, switchMap, take } from 'rxjs';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { DocumentosService } from 'src/app/modules/services/documentos/documentos.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss']
})

export class UploadModalComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef | null = null;
  @Input() isDocument: boolean = false;
  @Input() isAnotation: boolean = false;
  @Input() isEditMode: boolean = false;
  @Input() data: any = {};
  selectedFiles: File[] = [];
  typeDocument_id: any;
  contract_id: any;
  formDocument!: FormGroup;
  form!: FormGroup;
  searchControlDocument = new FormControl(null, [Validators.required]);
  selectedOptionDocument: any;
  filteredOptionsDocumentTypes: any[] = [];
  fileNames: string[] = [];
  annotation: any
  document: any
  subscriptions: Subscription[] = [];
  selectedFile: File | null = null;
  maxFileSize: number = 25 * 1024 * 1024; // 25MB by default
  file: File | null = null;
  fileChanged: boolean = false;
  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<UploadModalComponent>,
    @Inject(MAT_DIALOG_DATA) public uploadData: any,
    private documentService: DocumentosService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) {
    this.isDocument = this.uploadData.isDocument;
    this.isAnotation = this.uploadData.isAnotation;
    this.annotation = this.uploadData?.annotation;
    this.document = this.uploadData?.document;
    this.isEditMode = this.uploadData?.isEditMode;
    this.contract_id = this.uploadData?.contract_id;
    if (this.isAnotation) {
      this.form = this._fb.group({
        anotacao: [null, Validators.required]
      });
    } else {
      this.form = this._fb.group({
        anexo: [null, Validators.required],
        tipododocumento: [null, Validators.required],
        descricao: [null, Validators.required]
      });
    }


    this.searchControlDocument.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => {
        return this.documentService.listTypeDocuments().pipe(
          catchError(() => of([]))
        )
      })
    ).subscribe({
      next: (results: any) => {

        this.filteredOptionsDocumentTypes = results.content

        if (results?.content?.length) {
          this.filteredOptionsDocumentTypes = results.content;
          this.searchControlDocument.setErrors(null);
        } else {
          this.filteredOptionsDocumentTypes = [];
          this.searchControlDocument.setErrors({ noResults: true });
        }

      }, error: (err: any) => {
        this.filteredOptionsDocumentTypes = [];
        this.searchControlDocument.setErrors({ noResults: true });
      }
    });

  }
  ngOnInit(): void {
    this.isDocument = this.uploadData.isDocument;
    this.isAnotation = this.uploadData.isAnotation;
    this.annotation = this.uploadData?.annotation;
    this.document = this.uploadData?.document;
    this.isEditMode = this.uploadData?.isEditMode;

    this.searchControlDocument.setValue(this.document?.tipododocumento, { emitEvent: false });

    this.fileNames.push(this.document?.nomeArquivo)
    if (this.annotation && this.isEditMode) {

      this.populateField(this.annotation)
    } else if (this.isEditMode && this.document) {
      this.populateField(this.document)
    }
  }

  populateField(data: any) {

    if (this.isAnotation) {
      this.form.patchValue({
        anotacao: data?.descricao
      })
    }

    if (this.isDocument) {
      this.getSelectedDocumento(data);
      this.form.patchValue({
        anexo: data?.anexo,
        tipododocumento: data?.tipoDocumento?.id ?? data?.tipoDocumento?.nome,
        descricao: data?.descricao
      })

      this.selectedOptionDocument = data?.tipoDocumento;
      this.searchControlDocument.setValue(data?.tipoDocumento?.nome, { emitEvent: false });
      this.form.get('tipododocumento')?.setValue(data?.tipoDocumento?.nome);
      this.typeDocument_id = data?.tipoDocumento?.id;
      this.filteredOptionsDocumentTypes = [];
    }
  }
  onFileChange(event: any) {

    const file: File = event.target.files[0];
    if (file.size > this.maxFileSize) {
      const maxSize = this.maxFileSize / 1024 / 1024;
      return this.toastService.showError(
        `O tamanho do arquivo selecionado é maior do que o permitido. Selecione arquivos de até 25MB de tamanho. .`
      );
    }

    this.file = file;
    this.selectedFile = file;
    this.fileChanged = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64File: any = reader.result;
      const fileInfos: { name: string; size: number; type: string; base64: string; file:any}[] = [];

      fileInfos.push({
        name: file.name,
        size: file.size,
        type: file.type,
        base64: base64File,
        file: file,
      });

      this.form.patchValue({
        anexo: fileInfos[0]
      });

      if(this.isEditMode){
        this.form.patchValue({
          anexo: file,
          fileChanged: true
        });
      }
      this.fileNames = [file.name];
    };
  }

  back() {
    this.dialogRef.close()
  }

  onOptionSelectedDocument(event: any) {
    this.selectedOptionDocument = event.option.value;
    this.searchControlDocument.setValue(this.selectedOptionDocument.nome, { emitEvent: false });
    this.form.get('tipododocumento')?.setValue(this.selectedOptionDocument.nome);
    if (this.document) {
      this.document.tipoDocumento.id = this.selectedOptionDocument.id;
    }

    this.typeDocument_id = this.selectedOptionDocument.id;
    this.filteredOptionsDocumentTypes = [];
  }
  onSubmit() {
    if (this.isDocument) {
      const data = {
        ...this.form.value,
        idTipoDocumento: this.typeDocument_id,
        fileChanged: this.fileChanged
      }
      if (this.isEditMode) {

        data.idTipoDocumento = this.document.tipoDocumento.id;
        data.nomeArquivo = this.document.nomeArquivo
        let tipoMime = this.document.nomeArquivo.split('.').pop();

        if (!this.form.value.anexo) {
          data.tipoMime = tipoMime
        }
      }
      this.dialogRef.close(data)
    } else if (this.isAnotation) {

      if (this.isEditMode) {
        const annotation = {
          descricao: this.form.value.anotacao,
          dataCadastro: this.annotation.dataCadastro,
          id: this.annotation.id,
          usuario: this.annotation.usuarioCriacao
        }
        this.dialogRef.close(annotation)
      } else {
        const annotation = {
          descricao: this.form.value.anotacao
        }
        this.dialogRef.close(annotation)

      }
    }
  }
  getSelectedDocumento(id: string) {
    this.loadingService.showLoading();
    this.subscriptions.push(
      this.documentService
        .downloadDocument(this.contract_id, id)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response: any) => {
            const file = this.documentService.convertBlobToFile(response);
            this.selectedFile = file;
            const fileName = this.document?.nomeArquivo || 'default-name';
            if (file) {
              const renamedFile = new File([file], fileName, { type: file.type });
              this.selectedFile = renamedFile;
            }
            this.form.patchValue({
              anexo: this.selectedFile
            });
          },
          (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  triggerFileInputClick(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }
}
